import React from 'react';
import { observer } from 'mobx-react';
import { Heading2, Heading3 } from '../design-system/headings';
import { useTranslation } from 'react-i18next';
import DefaultTrans from './default-i18next-trans';

export const QuestionHeading = observer(({ ui }) => {
    const { t } = useTranslation('assessment');

    return (
        <>
            <Heading3 lighter mb={8}>
                {t(ui.pretitle)}
            </Heading3>
            <Heading2 bold>{t(ui.title)} </Heading2>
            {ui.description ? (
                <DefaultTrans translatedString={t(ui.description)} />
            ) : (
                <p />
            )}
        </>
    );
});
